import React from 'react';
import { PersonagemCard } from './PersonagemCard';
import { Personagem } from '../../../types/personagem';
import { PersonagemStats } from '../../../utils/personagemStats';

interface PersonagemCardGridProps {
  personagens: Personagem[];
  statsById: Map<string, PersonagemStats>;
  loadingStats: boolean;
  onOpenDetail: (personagem: Personagem) => void;
  onOpenImage: (imageUrl: string) => void;
  onEdit: (personagem: Personagem) => void;
  onDelete: (personagem: Personagem) => void;
  onToggleAtivo: (personagem: Personagem) => void;
}

const emptyStats: PersonagemStats = { totalEventos: 0, receitaTotal: 0, receitaMedia: 0, eventos: [] };

export const PersonagemCardGrid: React.FC<PersonagemCardGridProps> = ({
  personagens,
  statsById,
  loadingStats,
  onOpenDetail,
  onOpenImage,
  onEdit,
  onDelete,
  onToggleAtivo
}) => {
  return (
    <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 auto-rows-fr">
      {personagens.map((personagem) => (
        <PersonagemCard
          key={personagem.id}
          personagem={personagem}
          stats={statsById.get(personagem.id) || emptyStats}
          loadingStats={loadingStats}
          onOpenDetail={onOpenDetail}
          onOpenImage={onOpenImage}
          onEdit={onEdit}
          onDelete={onDelete}
          onToggleAtivo={onToggleAtivo}
        />
      ))}
    </div>
  );
};
